export default __webpack_public_path__ + "static/media/logo_gobierno_jalisco_horizontal.ec7aa464.png";